import { useEffect, useState } from "react";
import { useSubmitForgotPasswordMutation } from "../../../services/RegisterAPI";
import { useGetColorThemeQuery } from "../../../services/commonAPI";
import { useNavigate } from "react-router-dom";
import Banner from "./banner"
import "./style.css"


function Registerform() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: "",
    });

    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);

    const {
        data: colorthemeData,
    } = useGetColorThemeQuery();

    const [submitLoginForm, { isLoading }] = useSubmitForgotPasswordMutation();


    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage(null);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(null);

        try {
            const response = await submitLoginForm(formData).unwrap();
            setMessage(response.message);
            if (response.success === true) {
                setMessageType("success");
                console.log("response")
                const responseEmail = response?.email
                setTimeout(() => {
                    navigate("/forgot-otp", { state: { email: responseEmail } });
                }, 3000);
            } else {
                setMessageType("error");
            }
        } catch (error) {
            setMessage(error.data?.message || error.data?.error || "Failed to Login.");
            setMessageType("error");
        }
    };

    return (
        <>
            <Banner />
            <div className="register-form forgot-password-form">
                <div className="container">
                    <div className="row justify-center">
                        <div className="col-md-6 col-lg-6 col-sm-12">
                            <div className="left-div">
                                <h4>Forgot Password</h4>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-20">
                                        <label>Enter Email *</label>
                                        <br />
                                        <input
                                            type="text"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="primary-button w-100"
                                        disabled={isLoading}
                                        style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}
                                    >
                                        {isLoading ? "Submitting..." : "Submit"}
                                    </button>
                                </form>

                                {message && (
                                    <p
                                        className={
                                            messageType === "success"
                                                ? "success-message"
                                                : "error-message"
                                        }
                                    >
                                        {message}
                                    </p>
                                )}
                            </div>
                        </div>
  
                    </div>
                </div>
            </div>
        </>

    );
}

export default Registerform;
